import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { NAPRiskMitigationPayload } from '@/libs/fleet-api/services/nap';
import { Divider, Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { FC } from 'react';

type RiskMitigationForm =
	NAPRiskMitigationPayload['riskAndMitigations'][number];

export const useRiskMitigationModal = () => {
	return useAsyncModal<RiskMitigationForm, RiskMitigationForm>();
};

const RiskMitigationModal: FC<ReturnType<typeof useRiskMitigationModal>> = (
	props,
) => {
	const { form, fieldName } = useForm<RiskMitigationForm>();

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Add Risiko dan Mitigasi</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ span: 4 }}
				wrapperCol={{ span: 20 }}
			>
				<Form.Item
					label="Risiko"
					style={{ marginTop: 20 }}
					name={fieldName('risk')}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Mitigasi"
					style={{ marginTop: 20 }}
					name={fieldName('mitigation')}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>
			</Form>
		</FleetModal>
	);
};

export default RiskMitigationModal;
